import { useQuery } from '@apollo/react-hooks';
import { get } from 'lodash';
import getPlatformCourse from '../api/getPlatformCourse.query';

export default (vendorUuid, productID, config) => {
    const { data, loading, error } = useQuery(getPlatformCourse, {
        variables: { vendorUuid, productID },
        skip: !vendorUuid || !productID || config?.skip,
    });

    if (error) {
        console.log('Error', error);
    }

    const courses = data?.getPlatformCourse?.data;
    const authoriseError = data?.getPlatformCourse?.authoriseError || null

    return {
        loading,
        data: {
            ...courses,
            productID,
        },
        error,
        authoriseError,
    };
};
